module.exports = __webpack_public_path__ + "img/image-space-capsule-portrait.27efd604.jpg";